module.exports = __webpack_public_path__ + "static/media/bus-school.26959e73.svg";